var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6V4.66667C11.3333 4.31305 11.1929 3.97391 10.9428 3.72386C10.6928 3.47381 10.3536 3.33334 10 3.33334H3.33333C2.97971 3.33334 2.64057 3.47381 2.39052 3.72386C2.14048 3.97391 2 4.31305 2 4.66667V8.66667C2 9.02029 2.14048 9.35943 2.39052 9.60948C2.64057 9.85953 2.97971 10 3.33333 10H4.66667M6 12.6667H12.6667C13.0203 12.6667 13.3594 12.5262 13.6095 12.2761C13.8595 12.0261 14 11.687 14 11.3333V7.33334C14 6.97971 13.8595 6.64058 13.6095 6.39053C13.3594 6.14048 13.0203 6 12.6667 6H6C5.64638 6 5.30724 6.14048 5.05719 6.39053C4.80714 6.64058 4.66667 6.97971 4.66667 7.33334V11.3333C4.66667 11.687 4.80714 12.0261 5.05719 12.2761C5.30724 12.5262 5.64638 12.6667 6 12.6667ZM10.6667 9.33334C10.6667 9.68696 10.5262 10.0261 10.2761 10.2761C10.0261 10.5262 9.68696 10.6667 9.33333 10.6667C8.97971 10.6667 8.64057 10.5262 8.39052 10.2761C8.14048 10.0261 8 9.68696 8 9.33334C8 8.97971 8.14048 8.64058 8.39052 8.39053C8.64057 8.14048 8.97971 8 9.33333 8C9.68696 8 10.0261 8.14048 10.2761 8.39053C10.5262 8.64058 10.6667 8.97971 10.6667 9.33334Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOutline);
export default __webpack_public_path__ + "static/media/CashOutline.1c08f11d10bf12bb85c3e6fbeac4c2a2.svg";
export { ForwardRef as ReactComponent };